<template>
    <div>
        <bv-top></bv-top>
        <van-notice-bar color="#1989fa" background="#ecf9ff">
            <van-badge :content="checkedNum">
                <van-icon name="checked" color="#07c160"/>
                已回复
            </van-badge>
            &nbsp;&nbsp;&nbsp;
            <van-badge :content="todoNum">
                <van-icon name="todo-list" color="#ff976a"/>
                待回复
            </van-badge>
        </van-notice-bar>
        <van-collapse :key="messageBoard.sysGuid" v-for="(messageBoard, index) in list" accordion v-model="activeName">
            <van-collapse-item :name="index + 1">
                <template #title>
                    <div>
                        <van-icon name="checked" color="#07c160" v-if="messageBoard.status === '0'"/>
                        <van-icon name="todo-list" color="#ff976a" v-else/>
                        {{messageBoard.title}}
                    </div>
                </template>
                问：{{messageBoard.summary}}
                <van-divider/>
                答：{{messageBoard.status === '0' ? messageBoard.replyComment : '尚未回复...'}}
            </van-collapse-item>
        </van-collapse>
        <van-empty v-show="noResultShow" description="没有更多内容"/>
    </div>
</template>

<script>

    import Top from '@/views/components/Top'
    import {Collapse, CollapseItem, Divider, NoticeBar} from 'vant'
    import {fetchMessageBoard} from '@/api/public/messageBoard'

    export default {
        name: 'MessageBoardList',
        components: {
            BvTop: Top,
            VanCollapse: Collapse,
            VanCollapseItem: CollapseItem,
            VanDivider: Divider,
            VanNoticeBar: NoticeBar
        },
        data() {
            return {
                list: [],
                noResultShow: false,
                activeName: "1",
                checkedNum: 0,
                todoNum: 0
            }
        },
        methods: {
            initMessageBoards() {
                fetchMessageBoard().then(res => {
                    if (res.data == null || res.data.length === 0) { // 查无数据
                        this.noResultShow = true
                    }
                    this.checkedNum = res.data.filter(item => item.status === '0').length;
                    this.todoNum = res.data.filter(item => item.status != '0').length;
                    this.list = res.data
                })
            }
        },
        mounted() {
            this.initMessageBoards()
        }
    }
</script>